<app-events-invitations-list
  [invitationsPage]="myInvitations$ | async"
  [isLoading]="isLoading"
  (acceptInvitationClick)="handleAcceptInvitationClick($event)"
  (declineInvitationClick)="handleDeclineInvitationClick($event)"
  (pageChange)="handlePageChange($event)" />
